// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__2eUJ-","load6":"Spinner_load6__qkRZ7","round":"Spinner_round__2JGq_"};